import React from "react";
import Card from "react-bootstrap/Card";
import Topbar from "../../components/Topbar";
import Button from "react-bootstrap/Button";
import Nav from "react-bootstrap/Nav";
import TxtToImg from "../../components/Generator/TxtToImg";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Image from "react-bootstrap/Image";
import Doctors from "../../images/Doctors.png";

// Fourth lesson on AI Art; introduces students to
// the bias correction toggle as well as the need for
// bias correction in AI image generation.

class FourthLesson extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "Bias Correction",
      length: "15 minutes",
      description:
        "This lesson will go over bias correction and why it is important in an AI image generator",
      topics: ["Bias", "Diversity"],
      page: "../lessons/fourth",
    };
  }

  render() {
    return (
      <div className="lesson" style={{ backgroundColor: "#727c8f" }}>
        <Topbar />
        <div style={{ height: "1vh" }}></div>
        <div className="d-flex justify-content-center">
          <Card>
            <Card.Header className="bg-success text-white text-center">
              <h3>{this.state.title}</h3>
            </Card.Header>
            <Card.Body style={{ maxWidth: "75vw" }}>
              <div className="text-center">
                <Card.Title>Lesson Length: {this.state.length}</Card.Title>
              </div>
              <div style={{ height: "1vh" }}></div>
              <div className="text-center">
                <Image src={Doctors} width="25%" height="25%" />
              </div>
              <div style={{ height: "1vh" }}></div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  Hello, and welcome to our lesson on the bias correction toggle
                  of our image generator. We will be going over what bias
                  correction is and why it is useful.
                </Card.Text>
              </div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  Bias is when someone has a preference for or against something
                  or someone, often without realizing it. In the case of
                  creating images of people, biases can lead to images that
                  don't accurately represent the diversity of real people. For
                  example, if the people creating the images are used to seeing
                  mostly light-skinned people, they might unintentionally make
                  the skin tones of darker-skinned people look unnatural or less
                  realistic.
                </Card.Text>
              </div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  Artificial intelligence models such as Stable Diffusion can be
                  affected by bias due to the potential for the image data it is
                  built on to be biased. For example, images in the data Stable
                  Diffusion is trained on that feature construction workers could
                  have a gender bias. If the image generator was to generate an
                  image with the prompt of "construction worker" it might be more
                  likely to produce a construction worker of a certain gender. Biases
                  can negatively affect the image produced.
                </Card.Text>
              </div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  That's where bias correction comes in. It's a process that can
                  be used to help eliminate or reduce biases in images. In the
                  context of Stable Diffusion, which is a type of image
                  generation algorithm, bias correction can be used to create
                  images of more diverse people by adjusting the algorithm to
                  create more realistic and varied skin tones, facial features,
                  and other characteristics.
                </Card.Text>
              </div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  By using bias correction techniques, the resulting images can
                  be more representative of the diverse range of people in the
                  real world, which can help to promote inclusivity and reduce
                  stereotyping. Bias correction should be used in further 
                  development of artificial intelligence models to remedy these 
                  issues. Ultimately, bias correction is an important tool for 
                  creating more accurate and diverse representations of people 
                  in images.
                </Card.Text>
              </div>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  Now then, try creating an image of a "group of doctors" with
                  bias correction turned off and then again with it turned on:
                </Card.Text>
              </div>
              <Container fluid>
                <Row>
                  <Col md={{ span: 2, offset: 0 }}>
                    <br />

                    <br />
                  </Col>
                  <Col md={{ span: 8, offset: 0 }}>
                    <br />
                    <TxtToImg />
                    <br />
                  </Col>
                  <Col md={{ span: 2, offset: 0 }}>
                    <br />

                    <br />
                  </Col>
                </Row>
              </Container>
              <div style={{ padding: "1vh 5vw" }}>
                <Card.Text className="text-left">
                  How do the two images differ? Does the second image appear to
                  feature a more diverse group of doctors? Feel free to test out
                  using bias correction more above!
                </Card.Text>
              </div>
              <div
                style={{
                  fontSize: "4.0rem",
                  fontWeight: "bold",
                  padding: "1vh",
                }}
              >
                <div className="text-center">Congratulations!</div>
              </div>
              <div
                style={{
                  fontSize: "2.0rem",
                  fontWeight: "bold",
                  padding: "1vh",
                }}
              >
                <div className="text-center">
                  You have completed your fourth lesson in Diffractive!
                </div>
              </div>
              <div style={{ height: "1vh" }}></div>
              <div className="d-flex justify-content-center">
                <Nav>
                  <Nav.Link id="FourthReturn" href="../lessons" variant="dark">
                    <Button variant="info">Return to Lessons</Button>
                  </Nav.Link>
                </Nav>
              </div>
            </Card.Body>
          </Card>
        </div>
      </div>
    );
  }
}

export default FourthLesson;
